import { lazy } from 'react';

const RejectedAdmCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/adm/certificates-rejected',
			component: lazy(() => import('./RejectedCertificationContainer'))
		}
	]
};

export default RejectedAdmCertificationConfig;



